import PropTypes from 'prop-types';
import CheckBox from './CheckBox';
import css from './CheckBox.scss';

const classes = {
	root: css.checkBox,
	content: css.checkBoxContent,
	wrapper: css.checkBoxWrapper,
	input: css.checkBoxInput,
	label: css.checkBoxLabel,
	yes: css.checkBoxYes,
	no: css.checkBoxNo,
	isDisabled: css.isDisabled,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	id: PropTypes.string.isRequired,
	labelYes: PropTypes.string,
	labelNo: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
};

const defaultProps = {
	className: '',
	classes,
	labelYes: 'Cabina<br/>Doble',
	labelNo: 'Cabina<br/>Plus',
	onClick: Function.prototype,
	checked: undefined,
	disabled: false,
};

CheckBox.displayName = 'CheckBox';
CheckBox.propTypes = propTypes;
CheckBox.defaultProps = defaultProps;
export { CheckBox };
export default CheckBox;
